import Message from './Message/Message';
import { types } from './types';
function Actions (action, showAlert, variables, setOpenVariable, automId) {
    if (action.actionName === types.MESSAGE) {
        return <Message action={action} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
    }
}
export default Actions;